module.exports = __webpack_public_path__ + "img/22.3a8a81dd.jpg";